import _ from 'underscore';

var trackingID = void 0;
var init = _.once(function () {
    //window.dataLayer = window.dataLayer || [];
    (function (a, t, c, l, o, u, d) {
        a['_genesysJourneySdk'] = o;a[o] = a[o] || function () {
            (a[o].q = a[o].q || []).push(arguments);
        }, a[o].l = 1 * new Date();u = t.createElement(c), d = t.getElementsByTagName(c)[0];u.async = 1;u.src = l;d.parentNode.insertBefore(u, d);
    })(window, document, 'script', 'https://app.genesys.cloud/journey/sdk/js/web/v1/ac.js', 'ac');
    ac('init', 'efbfd147-330b-400c-9881-a632deb00a06', { region: 'use2' });
    ac('pageview');
});

export default (function (AppConfig) {
    return function () {
        init();
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-tracking-angular/adapters/AltocloudAnalytics.js
// module id = 907
// module chunks = 0